module.exports = __webpack_public_path__ + "img/product.986f2aa9.svg";